import axiosInstance from "@/store/axios.instance";
import Vue from "vue";

export default {
    namespaced: true,
    state() {
        return {
            parameters: null,
            parameter: null,
        }
    },
    mutations: {
        setParameters(state, parameters) {
            Vue.set(state, 'parameters', parameters);
        },
        setParameter(state, parameter) {
            state.parameter = parameter
        }

    },
    actions: {
        async fetchParameters({commit}) {
           await axiosInstance.get('/zon/parameters')
                .then(result => commit('setParameters', result.data))
        },
        wijzigParameter({ commit,dispatch},parameter){
            axiosInstance.post('/zon/parameters/parameter/wijzigen',parameter)
                .then(result => {
                    commit('setParameter', result.data)
                    dispatch('fetchParameters')
                });
        },
        wijzigParameters({ commit,dispatch},parameters) {
            axiosInstance.post('/zon/parameters/wijzigen', parameters)
                .then(result => {
                    commit('setParameters', result.data)
                });
        }
    },
    getters: {
        getParameterById: (state) => (id) => {
            return state.parameters.find(param => param.id === id);
        },
        getParameterValueByNaam: state => naam => {
            if (!Array.isArray(state.parameters)) return null;
            const param = state.parameters.find(p => p.naam === naam);
            return param ? param.waarde : null;
        },
        getParameterByNaam: state => naam => {
            return state.parameters?.find(p => p.naam === naam) || null;
        }

        // getParameterValueByNaam: state => naam => {
        //     if (!Array.isArray(state.parameters)) return null;
        //     return state.parameters.find(p => p.naam === naam);
        // },
        // getParameterByNaam: (state) => (naam) => {
        //     const param = state.parameters.find(param => param.naam === naam);
        //     return param ? param : null;
        // },
    },

}
